import { Matches, MaxLength, IsOptional, IsNotEmpty, IsEnum } from "class-validator";
import { ApiProperty } from "@nestjs/swagger";
import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";


export class ApplyForLeavesDTO {

    @ApiProperty()
    @IsOptional()
    applyForLeavesId: number;

    @ApiProperty()
    @IsOptional()
    employeeId: number;

    @ApiProperty()
    @IsNotEmpty({ message: "Employee Code should not be empty" })
    employeeCode: string;

    @ApiProperty()
    @IsNotEmpty({ message: 'Type Of leave should not be empty' })
    typeOfLeave: number;

    @ApiProperty()
    fromDate: Date;

    @ApiProperty()
    appliedDate: string;

    @ApiProperty()
    toDate: Date;

    @ApiProperty()
    @IsNotEmpty({ message: 'Leave To day should not be empty' })
    leaveFromDay: string;

    @ApiProperty()
    @IsNotEmpty({ message: 'Leave To day should not be empty' })
    leaveToDay: string;

    @ApiProperty()
    noOfDays: number;

    @ApiProperty()
    @IsNotEmpty({ message: 'Leave Reason should not be empty' })
    leaveReason: string;

    @ApiProperty()
    @IsNotEmpty({ message: 'Leave address should not be empty' })
    leaveAddress: string;

    @ApiProperty()
    @IsEnum(LeaveApprovalStatusEnum)
    @IsOptional()
    status: LeaveApprovalStatusEnum

    @ApiProperty()
    @IsNotEmpty({ message: 'employee name should not be empty' })
    employeeName?: string;


    @ApiProperty()
    isActive: boolean;
    createdAt: Date;

    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'Created user allows maximun 40 characters' })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: 'Created user should contain only characters' })
    createdUser: string;

    updatedAt: Date;
    
    @ApiProperty()
    rejectionReason: string;


    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: 'Updated User allows maximum 40 characters' })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"), { message: 'Updated user should contain only characters' })
    updatedUser: string;

    @ApiProperty()
    versionFlag: number;

    typeOfLeaveDesc: string;

}